<template>
  <v-row>
    <!-- on hand -->

    <template v-if="isActive === 'All' || isActive === 'onhand'">
      <ListTotalCount
        icon="mdi-hand-coin-outline"
        label="ONU On-hand"
        :value="data.onHand.total"
      ></ListTotalCount>
      <PerTypeTotalCount
        :value="data.onHand.zte"
        label="ZTE"
      ></PerTypeTotalCount>
      <PerTypeTotalCount
        :value="data.onHand.huawei"
        label="HUAWEI"
      ></PerTypeTotalCount>
      <PerTypeTotalCount
        :value="
          data.onHand.fiberhome"
        label="FIBERHOME"
      ></PerTypeTotalCount>
    </template>

    <template v-if="isActive === 'All' || isActive === 'released'">
      <ListTotalCount
        icon="mdi-arrow-up-bold-outline"
        label="ONU Release"
        :value="data.released.total"
      ></ListTotalCount>
      <PerTypeTotalCount
        :value="data.released.zte"
        label="ZTE"
      ></PerTypeTotalCount>
      <PerTypeTotalCount
        :value="
          data.released.huawei"
        label="HUAWEI"
      ></PerTypeTotalCount>
      <PerTypeTotalCount
        :value="
          data.released.fiberhome"
        label="FIBERHOME"
      ></PerTypeTotalCount>
    </template>

    <template v-if="isActive === 'All' || isActive === 'activated'">
      <ListTotalCount
        icon="mdi-check-circle-outline"
        label="ONU Activated"
        :value="
          data.activated.total
        "
      ></ListTotalCount>
      <PerTypeTotalCount
        :value="data.activated.zte"
        label="ZTE"
      ></PerTypeTotalCount>
      <PerTypeTotalCount
        :value="data.activated.huawei"
        label="HUAWEI"
      ></PerTypeTotalCount>
      <PerTypeTotalCount
        :value="data.activated.fiberhome"
        label="FIBERHOME"
      ></PerTypeTotalCount>
    </template>

    <template v-if="isActive === 'All' || isActive === 'defective'">
      <ListTotalCount
        icon="mdi-alert-outline"
        label="Defective ONU"
        :value="data.defective.total"
      ></ListTotalCount>
      <PerTypeTotalCount
        :value="data.defective.zte"
        label="ZTE"
      ></PerTypeTotalCount>
      <PerTypeTotalCount
        :value="data.defective.huawei"
        label="HUAWEI"
      ></PerTypeTotalCount>
      <PerTypeTotalCount
        :value="data.defective.fiberhome"
        label="FIBERHOME"
      ></PerTypeTotalCount>
    </template>

    <template v-if="isActive === 'All' || isActive === 'returned'">
      <ListTotalCount
        icon="mdi-arrow-down-bold-outline"
        label="Returned from WH"
        :value="data.returned.total"
      ></ListTotalCount>
      <PerTypeTotalCount
        :value="data.returned.zte"
        label="ZTE"
      ></PerTypeTotalCount>
      <PerTypeTotalCount
        :value="data.returned.huawei"
        label="HUAWEI"
      ></PerTypeTotalCount>
      <PerTypeTotalCount
        :value="data.returned.fiberhome"
        label="FIBERHOME"
      ></PerTypeTotalCount>
    </template>

     <template v-if="isActive === 'All' || isActive === 'registered'">
      <ListTotalCount
        icon="mdi-registered-trademark"
        label="Registered"
        :value="data.registered.total"
      ></ListTotalCount>
      <PerTypeTotalCount
        :value="data.registered.zte"
        label="ZTE"
      ></PerTypeTotalCount>
      <PerTypeTotalCount
        :value="data.registered.huawei"
        label="HUAWEI"
      ></PerTypeTotalCount>
      <PerTypeTotalCount
        :value="data.registered.fiberhome"
        label="FIBERHOME"
      ></PerTypeTotalCount>
    </template>
  </v-row>
</template>

<script>
import PerTypeTotalCount from "../PerTypeTotalCount.vue";
import ListTotalCount from "../ListTotalCount.vue";

export default {
  name: "SummaryReport",
  components: {
    ListTotalCount,
    PerTypeTotalCount,
  },

  props: ["isActive"],

  data() {
    return {
      summaryReport: {},
      data: {
        onHand: {
          total: 0,
          huawei: 0,
          zte: 0,
          fiberhome: 0,
        },
        released: {
          total: 0,
          huawei: 0,
          zte: 0,
          fiberhome: 0,
        },
        activated: {
          total: 0,
          huawei: 0,
          zte: 0,
          fiberhome: 0,
        },
        defective: {
          total: 0,
          huawei: 0,
          zte: 0,
          fiberhome: 1,
        },
        registered: {
          total: 0,
          huawei: 0,
          zte: 0,
          fiberhome: 0,
        },
        returned: {
          total: 0,
          huawei: 0,
          zte: 0,
          fiberhome: 0,
        },
      },
    };
  },

  methods: {
    async getSummaryReport() {
      await this.$api
        .get("/dashboard/inventory/report?report=home")
        .then((response) => {
          // this.summaryReport = response.data;
          // console.log(response.data.data);
          this.data = response.data.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },

  created() {},

  mounted() {
    this.getSummaryReport();
  },

  computed: {
    // userRole() {
    //   return this.$store.getters.userRole;
    // },
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
